import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');
  const mustChangePassword = localStorage.getItem('mustChangePassword') === 'true';

  // No token - redirect to signin
  if (!token || token === 'undefined' || token === 'null') {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  if (mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  // Check if user has permission for this route
  if (!allowedRoles.includes(userRole)) {
    // Redirect to their own dashboard based on role
    const roleDashboard = {
      'tenant_admin': '/tenant-admin/admin',
      'faculty': '/faculty/dashboard',
      'student': '/student/dashboard',
      'coe': '/coe',
      'super_admin': '/super-admin/dashboard',
      'head_of_institution': '/head-of-institution/dashboard',
      'hod': '/head-of-institution/dashboard',
      'principal': '/head-of-institution/dashboard',
      'parent': '/parent/dashboard',  
      'librarian': '/librarian/dashboard',
      'head_guard': '/head-guard/dashboard',
      'guard': '/guard/dashboard',
      'evaluator': '/evaluator/dashboard', 
      'accountant': '/accountant/dashboard', 
    };
    
    // If userRole is not in the mapping, redirect to home
    const redirectPath = roleDashboard[userRole] || '/';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;